import { render, staticRenderFns } from "./pdkTable.vue?vue&type=template&id=72f9c08d&scoped=true"
import script from "./pdkTable.vue?vue&type=script&lang=js"
export * from "./pdkTable.vue?vue&type=script&lang=js"
import style0 from "./pdkTable.vue?vue&type=style&index=0&id=72f9c08d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f9c08d",
  null
  
)

export default component.exports